module.exports = "/images/google.png?9bbb835216dd93c205ec40850f9f649f";